import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["data"],
  _excluded2 = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Grid from "@/components/Grid";
import SearchNoResults from "@/components/SearchNoResults";
import { useSearchConfigQuery, useSearchEpisodeLazyQuery, useSearchTvShowLazyQuery } from "@/hooks";
import config, { getStoreId } from "@/lib/config";
import { GRID_PAGE_LIMIT } from "@/lib/constants";
import { useEffect, useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SearchResult(_ref) {
  var _res$data, _searchConfig$keyword, _hitWords$;
  let {
    mode,
    searchQuery,
    sort
  } = _ref;
  const res = useSearchConfigQuery({
    fetchPolicy: "cache-first"
  });
  const searchConfig = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.searchConfig;
  const hitWords = searchConfig === null || searchConfig === void 0 || (_searchConfig$keyword = searchConfig.keywordMinScore) === null || _searchConfig$keyword === void 0 ? void 0 : _searchConfig$keyword.filter(keywordWithScore => {
    const {
      keyword
    } = keywordWithScore;
    return keyword === searchQuery;
  });
  const minScoreValue = (hitWords === null || hitWords === void 0 ? void 0 : hitWords.length) > 0 ? (_hitWords$ = hitWords[0]) === null || _hitWords$ === void 0 ? void 0 : _hitWords$.score : searchConfig === null || searchConfig === void 0 ? void 0 : searchConfig.defaultMinScore;
  const minScore = minScoreValue;
  const [searchEpisode, _ref2] = useSearchEpisodeLazyQuery({
    nextFetchPolicy: "cache-first"
  });
  const {
      data: episodeData
    } = _ref2,
    episodeResult = _objectWithoutProperties(_ref2, _excluded);
  const [searchTvshow, _ref3] = useSearchTvShowLazyQuery({
    nextFetchPolicy: "cache-first"
  });
  const {
      data: tvshowData
    } = _ref3,
    tvshowResult = _objectWithoutProperties(_ref3, _excluded2);
  const items = useMemo(() => {
    if (mode === "valueplan") {
      return tvshowData === null || tvshowData === void 0 ? void 0 : tvshowData.search;
    } else {
      return episodeData === null || episodeData === void 0 ? void 0 : episodeData.search;
    }
  }, [mode, episodeData, tvshowData]);
  const result = useMemo(() => {
    if (mode === "valueplan") {
      return tvshowResult;
    } else {
      return episodeResult;
    }
  }, [mode, episodeResult, tvshowResult]);
  useEffect(() => {
    const validMode = ["valueplan", "channel", "store", "live"];
    if (validMode.includes(mode) && searchQuery && sort) {
      const storeId = getStoreId();
      const valuePlanId = config.valuePlanId.vod;
      const variables = {
        keyword: searchQuery,
        sort,
        offset: 0,
        limit: GRID_PAGE_LIMIT,
        minScore
      };
      if (mode === "channel") {
        variables.filter = {
          not: {
            "values.channel": [storeId, valuePlanId]
          }
          // "values.packages_type": PACKAGE_TYPE.svod,
        };

        searchEpisode({
          variables
        });
      } else if (mode === "store") {
        variables.filter = {
          "values.channel": storeId
          // "values.packages_type": PACKAGE_TYPE.tvod,
        };

        searchEpisode({
          variables
        });
      } else if (mode === "valueplan") {
        variables.filter = {
          "values.channel": config.valuePlanId.vod
        };
        searchTvshow({
          variables
        });
      } else if (mode === "live") {
        variables.filter = {
          "values.is_live": true,
          time_range: {
            "values.encode_end_date": {
              gte: "now"
            }
          }
        };
        searchEpisode({
          variables
        });
      }
    }
  }, [mode, searchQuery, sort]);
  return /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
    items: items
  }, result), {}, {
    limit: GRID_PAGE_LIMIT,
    noContent: /*#__PURE__*/_jsx(SearchNoResults, {
      searchQuery: searchQuery
    })
  }), `search-result-${mode}`);
}